import React from 'react';
import { parseExperience, formatExperience, digitsOnly } from '../../utils/employeeValidation';

export default function ExperienceInput({ value, onChange, inputClassName = '', disabled = false }) {
  const { years, months } = parseExperience(value);

  const emit = (nextYears, nextMonths) =>
    onChange(formatExperience(nextYears, nextMonths));

  const box = (val, onVal, label, max) => (
    <div className="relative flex-1">
      <input
        type="text"
        inputMode="numeric"
        value={val}
        disabled={disabled}
        placeholder="0"
        onChange={(e) => onVal(digitsOnly(e.target.value, 2))}
        className={`${inputClassName} pr-12`}
        aria-label={label}
      />
      <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[11px] font-medium text-slate-400 pointer-events-none">
        {label}
      </span>
      {max !== undefined && <span className="sr-only">Maximum {max}</span>}
    </div>
  );

  return (
    <div className="flex items-center gap-2">
      {box(years, (v) => emit(v, months), 'Years')}
      {box(months, (v) => emit(years, v), 'Months', 11)}
    </div>
  );
}